export default {
  CashReceipt: {
    title: 'Phiếu thu',
    filename: 'PHIEUTHU',
  },
  CashPayment: {
    title: 'Phiếu chi',
    filename: 'PHIEUCHI',
  },
  Cheque: {
    title: 'Phát hành séc',
    filename: 'PHATHANHSEC',
  },
  Deposit: {
    title: 'Nộp tiền vào tài khoản',
    filename: 'NOPTIENVAOTAIKHOAN',
  },
  InwardStock: {
    title: 'Phiếu nhập kho',
    filename: 'NHAPKHO',
  },
  OutwardStock: {
    title: 'Phiếu xuất kho',
    filename: 'XUATKHO',
  },
  AssetTransfer: {
    title: 'Chuyển kho',
    filename: 'CHUYENKHO',
  },
  JusticeReceipt: {
    title: 'Phân phối thu thi hành án',
    filename: 'PHANPHOITHU',
  },
  JusticeSelling: {
    title: 'Phân phối tiền bán tài sản',
    filename: 'PHANPHOIBAN',
  },
  AccountTransferSlipVoucher: {
    title: 'Phiếu kết chuyển tài khoản',
    filename: 'KETCHUYEN',
  },
  VoucherList: {
    title: 'Bảng tổng hợp chứng từ cùng loại',
    filename: 'CHUNGTUCUNGLOAI',
  },
  TicketList: {
    title: 'Biên lai',
    filename: 'BIENLAI',
  },
};
